import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState } from 'recoil';
import { isFullscreenAtom } from '../OnlineMapState';
import useAnalytics from '../../../hooks/useAnalytics';

export default function FullScreenControl(): JSX.Element {
  const { formatMessage: f } = useIntl();
  const [isFullScreen, setIsFullscreen] = useRecoilState<boolean>(isFullscreenAtom);
  const { trackEvent } = useAnalytics();

  const handleFullScreen = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    const element = document.getElementById('google-map-fullscreen');
    const isFullScreenTemp = !isFullScreen;
    trackEvent([
      'map',
      'click',
      isFullScreenTemp ? 'expand to fullscreen' : 'collapse from fullscreen',
    ]);

    setIsFullscreen(isFullScreenTemp);

    if (element && isFullScreenTemp) {
      element.requestFullscreen();
    } else if (element && !isFullScreenTemp) {
      document.exitFullscreen();
    }
  };

  const handleExitFullScreen = () => {
    if (document.fullscreenElement) {
      setIsFullscreen(true);
    } else {
      setIsFullscreen(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener('fullscreenchange', handleExitFullScreen);
    return () => {
      document.removeEventListener('fullscreenchange', handleExitFullScreen);
    };
  });

  return (
    <a
      id="fullscreen-control"
      className="e-button-sq"
      title={`${
        !isFullScreen
          ? f({ id: 'fullscreen.map.control.expand' })
          : f({ id: 'fullscreen.map.control.collapse' })
      }`}
      onClick={handleFullScreen}
    >
      <i
        className={`${
          !isFullScreen ? ' cmd-icons cmd-icon-expand' : 'cmd-icon cmd-icon-fullscreen-collapse'
        }`}
      />
    </a>
  );
}
